module.exports = __webpack_public_path__ + "img/A2030_eth-gold-exports.21b932b8.jpg";